// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1Bfld","fileDisabled":"File_fileDisabled__CkJeG"};